export const Version = () => {
    const appName =
        process.env.REACT_APP_APP_NAME || "风电叶片外部巡检数据平台";
    return (
        <div className="h-full w-full flex flex-row justify-center items-center">
            <img src="/bowongtec-logo.png" alt="上海伯望 Logo" className="h-[126px] mr-4" />
            <div className="flex flex-col gap-2">
                <div className="text-lg font-bold">{appName}</div>
                <div className="grid grid-cols-[auto_1fr] gap-2">
                    <div>版本号：</div>
                    <div>v1.1</div>
                    <div>发布日期：</div>
                    <div>2025/7/22</div>
                </div>
            </div>
        </div>
    );
};
